import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import Section from './Section';

const teaching = [
  {
    course: 'MKTG 321: Understanding AI Technologies for Business Problems',
    school: 'Stanford University',
    period: 'Jan – Mar 2026',
    description:
      'Applied AI/ML for business, from problem formulation to implementation: recommender systems, multi-sided platforms, generative AI, reinforcement learning, and LLMs.',
  },
  {
    course: 'CS 2110: Computer Organization and Programming',
    school: 'Georgia Institute of Technology',
    period: 'Jan 2023 – May 2024',
    description: 'Computer hardware, machine and assembly language, and C programming.',
  },
  {
    course: 'CS 1301: Introduction to Python',
    school: 'Georgia Institute of Technology',
    period: 'Jan 2022 – Dec 2022',
    description: 'Fundamentals of computing and problem-solving in Python.',
  },
];

const Teaching = () => {
  return (
    <Section id="teaching" title="Teaching">
      <Stack spacing={2.5}>
        {teaching.map((item) => (
          <Box key={item.course}>
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ sm: 'baseline' }}>
              <Typography variant="h6">{item.course}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap', ml: { sm: 2 } }}>
                {item.period}
              </Typography>
            </Stack>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
              Teaching Assistant, {item.school}
            </Typography>
            <Typography variant="body2">{item.description}</Typography>
          </Box>
        ))}
      </Stack>
    </Section>
  );
};

export default Teaching;
